import { AppointmentStatus, PayoutStatus } from "../contracts";
import { Rating } from "./Rating";
import { UserPatient } from "./UserPatient";
import { UserPsi } from "./UserPsi";

export type RescheduleRequestData = {
  id: number;
  status: string;
  formattedDate: string;
  formattedTime: string;
  myRequest: boolean;
  pendingByMe: boolean;
  color: string;
  bgColor: string;
  title: string;
  icon: string;
  descriptionDate: string;
  descriptionTime: string;
  userTypeLabel: string;
  descriptionStatus: string;
};

export type Appointment = {
  id: number;
  online: boolean;
  user: UserPatient;
  psychologist: UserPsi;
  status: AppointmentStatus;
  status_label: string;
  status_color: string;
  status_icon: string;
  date: string;
  updated_at?: string;
  formatted_date: string;
  formatted_time: string;
  call_provider: string;
  call_link: string;
  rescheduleRequest?: RescheduleRequestData;
  can_enter: boolean;
  payout?: AppointmentPayout | null;
  value: number;
  recurrency: {
    frequencyLabel: string;
    frequencyText: string;
    nextAppointmentDate: string;
    interval: number;
    frequency: AppointmentReccurencyFrequency;
    reference_date: string;
  };
  paymentError: boolean;
  payment_requires_action: boolean;
  is_waiting_boleto_payment: boolean;
  type: string;
  chat?: AppointmentChat;
  payment_method: "card" | "boleto" | "partnership";
  can_reschedule: boolean;
  ratings: Rating[];
  receipt: string;
  original_value: number;
  coupon: {
    code: string;
    percent_off: number;
  };
  partnership: any;
  agora_token: string;
  agora_channel: string;
  timer: string;
  price: string;
  pg_status: string;
  client_secret?: string;
  has_chat: boolean;
  show_call_link: boolean;
};

export type AppointmentChat = {
  id: number;
  status: string;
  psychologist: {
    id: number;
    name: string;
  };
  created_at: string;
};

export enum AppointmentReccurencyFrequency {
  DAILY = "daily",
  WEEKLY = "weekly",
  MONTHLY = "monthly",
  YEARLY = "yearly",
}

export type AppointmentPayout = {
  id: number;
  status: PayoutStatus;
  date: string;
  value: string;
  arrival_date: string;
  net: number;
  payout_id: number;
  fee: number;
  main_payout_info: {
    status: PayoutStatus;
    arrival_date: string;
  };
  status_config: Record<string, { status: string; color: string }>;
  formatted_arrival_date: string;
};

export type AppointmentUser = {
  id: number;
  name: string;
  profile_image: string;
  deleted_at: string;
  handicapped: number;
  document_number: string;
};

export type AppointmentPsychologist = {
  id: number;
  name: string;
  profile_image: string;
  deleted_at: string;
  crp: string;
  rating: string;
  appointment_price: number;
};

export type AppointmentRating = {
  user_id: number;
  rating: number;
  description?: string;
  document_number: string;
};
